import { DECLARE_RESOURCES } from 'admin-on-rest/src/actions';
import { LOCATION_CHANGE } from 'react-router-redux';

import data from './data';
import list from './list';
import garbageCollection from './garbageCollection';

const initialState = {};
export default (
  previousState = initialState,
  action,
  dataReducer = data,
  listReducer = list
) => {
  if (action.type === LOCATION_CHANGE) {
    return garbageCollection(previousState, action.payload, ['product-activation', 'assortments', 'products', 'venues', 'product-order']);
  }
  if (action.type === DECLARE_RESOURCES) {
    const newState = action.payload.reduce(
      (acc, resource) => ({
        ...acc,
        [resource.name]: {
          props: resource,
          data: dataReducer(resource.name)(undefined, action),
          list: listReducer(resource.name)(undefined, action),
        },
      }),
      {}
    );
    return newState;
  }

  if (!action.meta || !action.meta.resource) {
    return previousState;
  }

  const resources = Object.keys(previousState);
  const newState = resources.reduce(
    (acc, resource) => ({
      ...acc,
      [resource]:
                action.meta.resource === resource
                  ? {
                    props: previousState[resource].props,
                    data: dataReducer(resource)(
                      previousState[resource].data,
                      action
                    ),
                    list: listReducer(resource)(
                      previousState[resource].list,
                      action
                    ),
                  }
                  : {
                    props: previousState[resource].props,
                    data: previousState[resource].data,
                    list: previousState[resource].list,
                  },
    }),
    {}
  );

  return newState;
};

export const getResources = (state) =>
  Object.keys(state).map((key) => state[key].props);
